// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-2mTVpdeh clearfix","box":"box-3NafPat8 fr"};